import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const UpdateAssigingUser = createAsyncThunk(
  "UpdateAssigingUser/UpdateAssigingUser",
  async (param, { rejectWithValue }) => {
    console.log(param, "param");

    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AssigingUser/ChangeAssigingUser",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ChangeAssigingUser = createSlice({
  name: "ChangeAssigingUser",
  initialState: {
    ChangeAssigingUser: [],
    loadingChangeAssigingUser: false,
    errorChangeAssigingUser: null,
  },

  extraReducers: (builder) => {
    builder

      .addCase(UpdateAssigingUser.pending, (state, action) => {
        state.loadingChangeAssigingUser = true;
        state.ChangeAssigingUser = action.payload;
        state.errorChangeAssigingUser = null;
      })
      .addCase(UpdateAssigingUser.fulfilled, (state, action) => {
        state.loadingChangeAssigingUser = false;
        state.ChangeAssigingUser = action.payload;
      })
      .addCase(UpdateAssigingUser.rejected, (state, action) => {
        state.loadingChangeAssigingUser = false;
        state.errorChangeAssigingUser = action.payload;
      });
  },
});

export default ChangeAssigingUser.reducer;
